export default __webpack_public_path__ + "media/zurb/img/about/team-profiles/rafi-profile-20e4939b5f6e29b775b6fcd576d4532f.png";